/**
 * This is the authenticated Admin API.
 * This should be used for all future admin endpoints, especially ones that
 * should not be accessible to the public.
 */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Auth } from "aws-amplify";
export const BASE_URL = process.env.REACT_APP_ADMIN_PORTAL_API_URL;

/**
 * Empty API for code generation with @rtk-query/codegen-openapi
 */
export const emptyAdminApi = createApi({
  reducerPath: "simplyAdminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    timeout: 10000,
    prepareHeaders: async (headers) => {
      try {
        const session = await Auth.currentSession();
        headers.set("Authorization", `Bearer ${session.getIdToken().getJwtToken()}`);
      } catch (error) {
        console.error("Unable to attach admin API auth token", error);
      }
      return headers;
    }
  }),
  tagTypes: ["RevenueTarget"],
  endpoints: () => ({})
});
